import { createTheme } from '@mui/material/styles';

const theme = createTheme({
	palette: {
		primary: {
			light: '#34CF76',
			main: '#1ab55c',
			dark: '#019C43',
		},
		secondary: {
			light: '#75E4A5',
			main: '#5bca8b',
			dark: '#42B172',
		},
	},
});

export default theme;
